module.exports = "/shared/img/fullscreen.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/fullscreen.svg
// module id = 437
// module chunks = 13